"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _oxygenConstants = require("@8x8/oxygen-constants");

var _oxygenUtils = require("@8x8/oxygen-utils");

var _constants = require("../../constants");

var _contents = _interopRequireDefault(require("../contents"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getTriggerRect = function getTriggerRect(_ref) {
  var anchor = _ref.anchor;
  if (!anchor) return null;
  var triggerBoundingRect = anchor.getBoundingClientRect();
  var relativeOffset = {
    x: triggerBoundingRect.left - anchor.offsetLeft,
    y: triggerBoundingRect.top - anchor.offsetTop
  };
  return {
    relativeOffset: relativeOffset,
    triggerBoundingRect: triggerBoundingRect
  };
};

var Controller =
/*#__PURE__*/
function (_Component) {
  _inherits(Controller, _Component);

  function Controller() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Controller);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Controller)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      relativeOffset: {
        x: 0,
        y: 0
      },
      triggerBoundingRect: {
        bottom: 0,
        height: 0,
        left: 0,
        right: 0,
        top: 0,
        width: 0
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (_ref2) {
      var eventKeyCode = _ref2.keyCode;

      if (eventKeyCode === _oxygenConstants.keyCode.ESCAPE && _this.props.onBlur) {
        _this.props.onBlur();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlePageClick", function (_ref3) {
      var target = _ref3.target;

      if (target instanceof window.Node && _this.props.anchor && !_this.props.anchor.contains(target) && _this.props.onBlur) {
        _this.props.onBlur();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      var newState = getTriggerRect(_this.props);

      if (newState) {
        _this.setState(newState);
      }
    });

    return _this;
  }

  _createClass(Controller, [{
    key: "render",
    value: function render() {
      if (!this.props.anchor) return null;
      var _this$state = this.state,
          relativeOffset = _this$state.relativeOffset,
          triggerBoundingRect = _this$state.triggerBoundingRect;
      var _this$props = this.props,
          children = _this$props.children,
          idealDirection = _this$props.idealDirection,
          testId = _this$props.testId,
          margin = _this$props.margin,
          shouldFocus = _this$props.shouldFocus;
      return _react.default.createElement(_oxygenUtils.OutsideEventBehavior, {
        onClick: this.handlePageClick
      }, _react.default.createElement(_contents.default, {
        idealDirection: idealDirection,
        testId: testId,
        onKeyDown: this.handleKeyDown,
        onResize: this.handleResize,
        relativeOffset: relativeOffset,
        margin: margin,
        shouldFocus: shouldFocus,
        triggerRect: triggerBoundingRect
      }, children));
    }
  }]);

  return Controller;
}(_react.Component);

exports.default = Controller;

_defineProperty(Controller, "propTypes", {
  anchor: _propTypes.default.shape({
    contains: _propTypes.default.func,
    getBoundingClientRect: _propTypes.default.func
  }),
  idealDirection: _propTypes.default.oneOf(_constants.directionsType),
  testId: _propTypes.default.string,
  margin: _propTypes.default.number,
  shouldFocus: _propTypes.default.bool,
  onBlur: _propTypes.default.func,
  children: _propTypes.default.node
});

_defineProperty(Controller, "defaultProps", {
  anchor: null,
  idealDirection: _constants.directions.bottom,
  testId: 'FLYOUT',
  margin: undefined,
  shouldFocus: false,
  onBlur: _noop.default,
  children: null
});

_defineProperty(Controller, "getDerivedStateFromProps", getTriggerRect);